import React, { useMemo } from 'react';

import { Box, List, ListItem, Typography } from '@mui/material';
import { DataGridPro, GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';

import { Bedbank } from '@luxuryescapes/contract-svc-bedbank';

interface Props {
  data: Array<Bedbank.ListSupplierProperty>;
}

export default function PropertiesTable({ data }: Props) {
  const columns: Array<GridColDef> = useMemo(
    () => [
      {
        field: 'supplierPropertyId',
        headerName: 'Id',
        disableColumnMenu: true,
        flex: 1,
        display: 'flex',
      },
      {
        field: 'supplier',
        headerName: 'Supplier',
        disableColumnMenu: true,
        flex: 1,
        display: 'flex',
      },
      {
        field: 'hotelName',
        headerName: 'Name',
        disableColumnMenu: true,
        flex: 2,
        display: 'flex',
      },
      {
        field: 'masterProperties',
        headerName: 'Master Properties',
        disableColumnMenu: true,
        flex: 4,
        display: 'flex',
        renderCell: ({ row }: GridRenderCellParams) => (
          <Box>
            <List>
              {row.masterProperties.map((masterProperty) => (
                <ListItem key={masterProperty.id}>
                  <Typography>
                    {masterProperty.id} ({masterProperty.supplier})
                  </Typography>
                </ListItem>
              ))}
            </List>
          </Box>
        ),
      },
      {
        field: 'countryCode',
        headerName: 'Address',
        disableColumnMenu: true,
        display: 'flex',
        renderCell: ({ row }: GridRenderCellParams) => (
          <div>
            <div>
              Country Code: <b>{row.countryCode}</b>
            </div>
            <div>{row.address}</div>
            <div>Latitude: {row.latitude}</div>
            <div>Longitude: {row.longitude}</div>
          </div>
        ),
        flex: 2,
      },
      {
        field: 'rating',
        headerName: 'Rating',
        disableColumnMenu: true,
        flex: 1,
        display: 'flex',
      },
      {
        field: 'numberOfRooms',
        headerName: 'Number Of Rooms',
        disableColumnMenu: true,
        flex: 1,
        display: 'flex',
      },
      {
        field: 'numberOfImages',
        headerName: 'Number Of Images',
        disableColumnMenu: true,
        flex: 1,
        display: 'flex',
      },
    ],
    [],
  );

  return (
    <>
      <DataGridPro
        columns={columns}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnSorting
        getRowHeight={() => 'auto'}
        getRowId={(row) => row.supplierPropertyId}
        rows={data}
        rowCount={data.length}
        density="compact"
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
      />
    </>
  );
}
